import section1 from './section-1';
import section2 from './section-2';
import section3 from './section-3';
import section4 from './section-4';
import section5 from './section-5';
import section6 from './section-6';
import Onlynumber from './onlynumber';
import Timer from './timer';
import Placeholder from './placeholder';
import placeholderInfo from './placeholder-info';
import layerInfo from './layer-info';
import Dday from './dday';
import Intromovie from "./intromovie";
import {gsap} from "gsap";

const page = promokit.page({
    type: 'fullpage-vertical',
    game: 'aion',
    menu: true,
    cnb: true,
    topButton: false,
    headerButton: {
        el: '.header-button',
        home: true,
        update:true,
        sns: true,
        theme: 'white'
    },
    footer: {
        fixed: true,
        theme:'white'
    },
    components: [
        section1,
        section2,
        section3,
        section4,
        section5,
        section6
    ],
});
const introMovie = new Intromovie();
promokit.store('isFullscreenVideo', true);
promokit.preload({
    complete: () => {
        console.log('preload complete');
        introMovie.start();
        introMovie.on('done', () => {
            promokit.store('isFullscreenVideo', false);
            new Dday({el: "#dday"}).countdown();
            if (page.nowIndex == 0) {
                gsap.timeline({paused: true})
                    .addLabel('start')
                    .from('#section-1', {opacity: 0, duration: .1}, 'start+=.1')
                    .from('#section-1 .sec-1__countdown', {opacity: 0, duration: 1.2, ease: Power2.easeInOut}, 'start+=1')
                    .from('#section-1 .sec-1__title', {opacity: 0, duration: .8, ease: Power2.easeOut}, 'start+=1')
                    .from('#section-1 .sec-1__subtitle', {opacity: 0, duration: .8, ease: Power2.easeOut}, 'start+=1')
                    .from('#section-1 .sec-1__logo', {opacity: 0, duration: .8}, 'start+=1')
                    .from('#section-1 .sec-1__arrow', {opacity: 0, duration: .8}, 'start+=1.4')
                    .from('#section-1 .sec-1__btn', {opacity: 0, duration: .8}, 'start+=1.4')
                    .from('#section-1 .sec-1__link', {x: 120, duration: .2, ease: Expo.easeOut}, 'start+=2.6')
                    .play();
            }
        });
    }
});

let authPhone = new Onlynumber({ el:"#auth-phone" }),
    authNumber = new Onlynumber({ el:"#auth-number" }),
    authPhoneConfirm = new Onlynumber({ el:"#auth-phone-confirm" }),
    authNumberConfirm = new Onlynumber({ el:"#auth-number-confirm" });

window.placeholder = {};
$.each(placeholderInfo, (key, value)=>{
    placeholder[key] = new Placeholder({
        el:value
    });
});
window.timerPreorder = new Timer({
    el:"#timer-preorder",
    minutes:5,
    start:false
});
window.timerPreorderConfirm = new Timer({
    el:"#timer-preorder-confirm",
    minutes:5,
    start:false
});
window.layerComplete = promokit.layer({
   el:'#layer-complete'
});
$.each(layerInfo, function(index, value){
    promokit.layer({
        el:value.el,
        buttons:value.btn,
    });
});


// WEBPACK FOOTER //
// ./src/js/index.js